import AppApi from "./index";
import { Admin, AdminBanRequest, CreateAdminRequest, UpdateAdminRequest } from "../types/admin";
import { Pagination } from "../types/pagination";

export default class AdminApi {
  constructor(private api: AppApi) {}

  public getAll() {
    return this.api.client.get<null, Admin[]>('/admins');
  }

  public getWithPagination(page: number, limit: number, name?: string) {
    return this.api.client.get<null, Pagination<Admin[]>>('/admins', {
      params: { page, limit, name },
    });
  }

  public getById(id: number) {
    return this.api.client.get<null, Admin>('/admins/' + id);
  }

  public create(admin: CreateAdminRequest) {
    return this.api.client.post<CreateAdminRequest, Admin>('/admins', admin);
  }

  public update(id: number, admin: UpdateAdminRequest) {
    return this.api.client.patch<UpdateAdminRequest, Admin>('/admins/' + id, admin);
  }

  public delete(id: number) {
    return this.api.client.delete('/admins/' + id);
  }

  public ban(request: AdminBanRequest) {
    return this.api.client.post<AdminBanRequest, boolean>('/admins/ban', request);
  }
}

